import React from 'react';

/**
 * NoneWidget
 * Renders nothing. Used as a failsafe when the AI determines
 * that no visualization is appropriate for the current question.
 */
export const NoneWidget = () => {
    return null;
};